import VerticalLine_VerticalShadowRightLineComponent from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/skinComps/BaseVerticalLine/VerticalShadowRightLine.skin';
import VerticalLine_VerticalShadowRightLineController from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/VerticalLine.controller';


const VerticalLine_VerticalShadowRightLine = {
  component: VerticalLine_VerticalShadowRightLineComponent,
  controller: VerticalLine_VerticalShadowRightLineController
};


export const components = {
  ['VerticalLine_VerticalShadowRightLine']: VerticalLine_VerticalShadowRightLine
};

